<template>
  <div id="tracking">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>รายการรหัสพัสดุ</h2>
          <b-row class="mb-3">
            <b-col sm="6" class="mb-2">
              <b-card bg-variant="light">
                <b-card-text>
                  <!-- {{ 'ชื่อผู้ใช้' }}<br>
                  {{ 'เบอร์โทรผู้ใช้' }} <br>
                  {{ 'ที่อยู่ผู้ใช้' }} -->
                  <b>ที่อยู่โกดังจีน:</b>  <br>
                  <small>
                    <!-- 收货人：{{ userData.userCode }} <br>
                    广东省 广州市 白云区 白云湖街道 <br>
                    夏茅南约商业街18号仓库1112-1 1688仓库 ({{ userData.userCode }}) <br>
                    邮编：510000 <br>
                    电话：17819689816 -->

                    收货人：({{ userData.userCode }})<br>
                    所在地区：广东省  广州市  白云区 白云湖街道<br>
                    详细地址 :  机场路 2721号 广花货运场 D区118号LICM 仓库 ({{ userData.userCode }}) 510000<br>
                    手机：17819689816
                  </small>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col sm="6">

              <b-card body-class="p-0">
                <b-card-body>
                  <b-form @submit="onSubmit">
                    <b-card-text>
                      <template v-if="userData.userType === 'A'">
                        <label for="form_userCode" class="mb-1">รหัสสมาชิก:</label>
                        <b-input-group class="mb-2">
                          <b-form-input id="form_userCode" v-model="form.userCode" type="text" autocomplete="off"></b-form-input>
                        </b-input-group>
                      </template>

                      <label for="form_suppliesCode" class="mb-1">รหัสพัสดุ:</label>
                      <b-input-group class="mb-2">
                        <b-form-input id="form_suppliesCode" v-model="form.suppliesCode" type="text" autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <!-- @click="getDataTracking" -->
                          <b-button variant="success" type="submit">ค้นหา</b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <b-form-checkbox v-model="form.isInThailand" name="check-in-thailand" switch value="Y" unchecked-value="">
                        แสดงเฉพาะที่ถึงไทย
                      </b-form-checkbox>
                    </b-card-text>
                  </b-form>

                  <b-button variant="outline-info" block to="RegisterTracking"><f-icon icon="cart-plus"></f-icon> สร้างรหัสพัสดุใหม่</b-button>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <!-- <hr class="my-2"> -->
          <b-skeleton-table
            :rows="4"
            :columns="3"
            :table-props="{ bordered: true, striped: true }"
            v-if="!dataReady"
          ></b-skeleton-table>
          <template v-if="dataReady">
            <h4><i>รายการรหัสพัสดุรอเข้าโกดัง</i></h4>
            <b-table striped bordered fixed table-variant="warning"
              :items="waitItemsWarehouse" :fields="fields"
              show-empty
              empty-text="ไม่พบข้อมูล"
              class="table-mini"
              >

              <template #cell(details)="data">
                  รหัสสมาชิก :	{{ data.item.userCode }} <br>
                  รหัสพัสดุ :	{{ data.item.suppliesCode }} <br>
                  ประเภท :	{{ data.item.category }} <br>
                  วลีช่วยจำ :	{{ data.item.mnemonicPhrase }} <br>
                  หมายเหตุ : {{ data.item.remark }}
                  <hr class="my-2">
                  ตีลังไม้ :	{{ data.item.woodenCrate }} <br>
                  เช็คสินค้า : {{ data.item.checkProduct }}
              </template>

              <template #cell(price)="data">
                  <!-- กว้าง :	{{ data.item.wide || '-' }} ซม.<br>
                  สูง :	{{ data.item.high || '-' }} ซม.<br>
                  ยาว :	{{ data.item.length || '-' }} ซม.<br>
                  น้ำหนัก :	{{ data.item.weight || '-' }} กก.<br>
                  จำนวน : {{ data.item.amount }} ชิ้น -->
                  กว้าง × สูง × ยาว :	{{ data.item.wide || '-' }} × {{ data.item.high || '-' }} × {{ data.item.length || '-' }} ซม.<br>
                  น้ำหนัก :	{{ data.item.weight || '-' }} กก.<br>
                  จำนวน : {{ data.item.amount }} ชิ้น <br>
                  น้ำหนักรวม : {{ data.item.totalWeight }} กก. <br>
                  ขนาดคิวรวม :	{{ data.item.totalQueue || '-' }} คิว

                  <hr class="my-2">
                  คิดตามกิโล : {{ data.item.priceByKilo ? data.item.priceByKilo : '-' }} บาท<br>
                  คิดตามขนาด : {{ data.item.priceByQueue ? data.item.priceByQueue : '-' }} บาท
              </template>

              <template #cell(transport)="data">
                  <!-- น้ำหนักรวม : {{ data.item.totalWeight }} กก.<br>
                  ขนาดคิวรวม :	{{ data.item.totalQueue || '-' }} คิว -->
                  <template v-if="data.item.transportType">
                    ประเภทการขนส่ง: <f-icon :icon="data.item.transportType === 'เรือ' ? 'ship' : 'truck'"></f-icon> <b>{{ data.item.transportType }}</b> <br>
                    <hr class="my-2">
                  </template>
                  เข้าโกดัง :	<b>{{ formatDate(data.item.InWarehouse) }}</b> <br>
                  ออกโกดัง :	<b>{{ formatDate(data.item.OutWarehouse) }}</b> <br>
                  ถึงไทย :	<b>{{ formatDate(data.item.InThailand) }}</b> <br>

                  <template v-if="data.item.deliverDoc">
                    <hr>
                    รหัสใบชำระสินค้า : <router-link :to="{ path: 'Delivery', query: { Doc : data.item.deliverDoc }}">{{ data.item.deliverDoc }}</router-link> <i style="font-size: 0.5rem;">(กำลังรอตรวจสอบ)</i>
                  </template>
              </template>

              <template #cell(action)="data">
                <b-button variant="info" size="sm" class="mb-1" v-b-tooltip.hover title="แก้ไขข้อมูล" @click="editDataTrack(data.item)" v-if="userData.userType === 'A'">
                  <f-icon icon="edit"></f-icon>
                </b-button>
                <b-button variant="danger" size="sm" class="mb-1" v-b-tooltip.hover title="ลบข้อมูล" @click="delConfirm(data.item)">
                  <f-icon icon="trash-alt"></f-icon>
                </b-button>
              </template>

            </b-table>
            <hr>
            <h4>รายการรหัสพัสดุ</h4>
            <b-table striped bordered fixed
              :items="items" :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              show-empty
              empty-text="ไม่พบข้อมูล"
              class="table-mini"
              >

              <template #cell(details)="data">
                  รหัสสมาชิก :	{{ data.item.userCode }} <br>
                  รหัสพัสดุ :	{{ data.item.suppliesCode }} <br>
                  ประเภท :	{{ data.item.category }} <br>
                  วลีช่วยจำ :	{{ data.item.mnemonicPhrase }} <br>
                  หมายเหตุ : {{ data.item.remark }}
                  <hr class="my-2">
                  ตีลังไม้ :	{{ data.item.woodenCrate }} <br>
                  เช็คสินค้า : {{ data.item.checkProduct }}
              </template>

              <template #cell(price)="data">
                  <!-- กว้าง :	{{ data.item.wide || '-' }} ซม.<br>
                  สูง :	{{ data.item.high || '-' }} ซม.<br>
                  ยาว :	{{ data.item.length || '-' }} ซม.<br>
                  น้ำหนัก :	{{ data.item.weight || '-' }} กก.<br>
                  จำนวน : {{ data.item.amount }} ชิ้น -->
                  กว้าง × สูง × ยาว :	{{ data.item.wide || '-' }} × {{ data.item.high || '-' }} × {{ data.item.length || '-' }} ซม.<br>
                  น้ำหนัก :	{{ data.item.weight || '-' }} กก.<br>
                  จำนวน : {{ data.item.amount }} ชิ้น <br>
                  น้ำหนักรวม : {{ data.item.totalWeight }} กก. <br>
                  ขนาดคิวรวม :	{{ data.item.totalQueue || '-' }} คิว

                  <hr class="my-2">
                  คิดตามกิโล : {{ data.item.priceByKilo ? data.item.priceByKilo : '-' }} บาท<br>
                  คิดตามขนาด : {{ data.item.priceByQueue ? data.item.priceByQueue : '-' }} บาท
              </template>

              <template #cell(transport)="data">
                  <!-- น้ำหนักรวม : {{ data.item.totalWeight }} กก.<br>
                  ขนาดคิวรวม :	{{ data.item.totalQueue || '-' }} คิว
                  <hr class="my-2"> -->
                  เข้าโกดัง :	<b>{{ formatDate(data.item.InWarehouse) }}</b> <br>
                  ออกโกดัง :	<b>{{ formatDate(data.item.OutWarehouse) }}</b> <br>
                  ถึงไทย :	<b>{{ formatDate(data.item.InThailand) }}</b> <br>

                  <template v-if="data.item.deliverDoc">
                    <hr>
                    รหัสใบชำระสินค้า : <router-link :to="{ path: 'Delivery', query: { Doc : data.item.deliverDoc }}">{{ data.item.deliverDoc }}</router-link> <i style="font-size: 0.5rem;">(กำลังรอตรวจสอบ)</i>
                  </template>
              </template>

              <template #cell(action)="data">
                <b-button variant="info" size="sm" class="mb-1" v-b-tooltip.hover title="แก้ไขข้อมูล" @click="editDataTrack(data.item)" v-if="userData.userType === 'A'">
                  <f-icon icon="edit"></f-icon>
                </b-button>
                <b-button variant="dark" size="sm" class="mb-1" v-b-tooltip.hover title="แก้ไขวลีช่วยจำ" @click="editDataMnemonicPhraseTrack(data.item)" v-if="userData.userType === 'U'">
                  <f-icon icon="tag"></f-icon>
                </b-button>
                <b-button variant="danger" size="sm" class="mb-1" v-b-tooltip.hover title="ลบข้อมูล" @click="delConfirm(data.item)">
                  <f-icon icon="trash-alt"></f-icon>
                </b-button>
              </template>

            </b-table>
            <b-pagination
              v-model="currentPage"
              pills first-number last-number
              v-if="totalRows > perPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>
          </template>

        </b-col>
      </b-row>

      <b-modal id="modalEditMnemonicPhrase" hide-footer>
        <template #modal-title>
          แก้ไขวลีช่วยจำของรหัสพัสดุ {{ formProductUpdate.suppliesCode }}
        </template>
        <div class="d-block">
          <h5 class="mb-1">รหัสพัสดุ : {{ formProductUpdate.suppliesCode }}</h5>
          <label class="mb-1">รหัสสมาชิก : {{ formProductUpdate.userName }}</label>
          <label class="mb-1" v-if="formProductUpdate.remark"> | หมายเหตุ : {{ formProductUpdate.remark }}</label>
          <hr />
          <label for="form_mnemonicPhrase_tracking" class="mb-1">วลีช่วยจำ:</label>
          <b-form-input id="form_mnemonicPhrase_tracking" class="mb-2" autocomplete="off" v-model="formProductUpdate.mnemonicPhrase" type="text" ></b-form-input>
        </div>
        <b-button class="mt-3" block @click="onEditMnemonicPhrase(formProductUpdate)">แก้ไขวลีช่วยจำ</b-button>
      </b-modal>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Tracking",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTracking()
  },
  data() {
    return {
      fields: [
        { key: 'details', label: 'รายละเอียดพัสดุ', thClass: 'py-2' },
        { key: 'price', label: 'คำนวณราคา', thClass: 'py-2' },
        { key: 'transport', label: 'รายละเอียดขนส่ง', thClass: 'py-2' },
        { key: 'action', label: 'จัดการข้อมูล', tdClass: 'p-2', thClass: 'py-2', class: 'w-110' }
      ],
      items: [
        // {
        //   "userName": "",
        //   "suppliesCode": "A123456",
        //   "mnemonicPhrase": "เขียวเสวย",
        //   "amount": "20",
        //   "weight": "1",
        //   "wide": "2",
        //   "high": "3",
        //   "length": "4",
        //   "category": "ไม่รู้",
        //   "InWarehouse": "2021-06-19",
        //   "OutWarehouse": "2021-06-30",
        //   "InThailand": "2021-06-30",
        //   "priceByKilo": "0",
        //   "priceByQueue": "60.2",
        //   "woodenCrate": null,
        //   "checkProduct": "",
        //   "totalWeight": null,
        //   "totalQueue": null,
        //   "remark": null,
        //   "other": null,
        //   "deliver": null
        // }
      ],
      formProductUpdate : {
        "userName": "",
        "suppliesCode": "",
        "mnemonicPhrase": "",
        "amount": "",
        "weight": "",
        "wide": "",
        "high": "",
        "length": "",
        "category": "",
        "InWarehouse": "",
        "OutWarehouse": "",
        "InThailand": "",
        "priceByKilo": "",
        "priceByQueue": "",
        "woodenCrate": null,
        "checkProduct": "",
        "totalWeight": null,
        "totalQueue": null,
        "remark": null,
        "other": null,
        "deliver": null
      },
      waitItemsWarehouse: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        isInThailand: '',
        suppliesCode: '',
        userCode: ''
      },
      dataReady: true,
    };
  },
  methods: {
    formatDate (dtDate) {
      if (dtDate) {
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0].substring(2, 4)
        return strDateShort
      } else {
        return ''
      }
    },
    editDataMnemonicPhraseTrack(data) {
      this.formProductUpdate = {...data};
      this.$bvModal.show('modalEditMnemonicPhrase')
    },
    getDataUser () {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        // if (this.userData.userType === 'A') {
        //   this.fields = [
        //     { key: 'details', label: 'รายละเอียดพัสดุ', thClass: 'py-2' },
        //     { key: 'price', label: 'คำนวณราคา', thClass: 'py-2' },
        //     { key: 'transport', label: 'รายละเอียดขนส่ง', thClass: 'py-2' },
        //     { key: 'action', label: 'จัดการข้อมูล', tdClass: 'p-2', thClass: 'py-2' }
        //   ]
        // }
      } else {
        this.$router.push('/Login')
      }
    },
    onSubmit (event) {
      event.preventDefault()
      this.getDataTracking()
    },
    getDataTracking () {
      this.dataReady = false;
      this.items = [];
      this.waitItemsWarehouse = [];

      this.totalRows = 0
      let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&userCode=' +
          uc +
          '&searchInThai=' +
          this.form.isInThailand +
          '&suppliesCode=' +
          this.form.suppliesCode,
          {
            headers: this.getHeaderAPI('Invoice_list', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('getDataTracking', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rowData.length
              // this.items = rs.data
              let rowData = rs.data
              rowData.forEach((item) => {
                if (item.InWarehouse) {
                  this.items.push(item)
                } else {
                  this.waitItemsWarehouse.push(item)
                }
              })
              this.totalRows = this.items.length
            } else {
              this.items = []
            }
          } else {
            this.items = []
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    onEditMnemonicPhrase () {
      this.dataReady = false;
      axios
        .post(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_update_mnemonicPhrase',
          {
            userName: this.userData.userName,
            invoiceId: this.formProductUpdate.invoiceId,
            suppliesCode: this.formProductUpdate.suppliesCode,
            mnemonicPhrase: this.formProductUpdate.mnemonicPhrase,
          },
          {
            headers: this.getHeaderAPI('Invoice_update_mnemonicPhrase', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('onEditMnemonicPhrase', response.data)

          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แก้ไขวลีช่วยจำเรียบร้อย","success")
              .then((result) => {
                this.$bvModal.hide('modalEditMnemonicPhrase')
              })
            this.dataReady = true

            this.getDataTracking()
          } else {
            // console.log('onUpdate Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขวลีช่วยจำได้","error")
            this.dataReady = true
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.$swal("ERROR", "ไม่สามารถแก้ไขวลีช่วยจำได้: "+ error, "error")
          // alert(error)
          // this.loginUser("http://licm-cargo.com/api/Authen/login")
          this.dataReady = true
        });
    },
    editDataTrack (dt) {
      console.log('editDataTrack', dt)
      this.$router.push('/User/UpdateTracking?suppliesCode='+dt.suppliesCode)
    },
    delConfirm (dt) {
      this.$swal({
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบข้อมูลพัสดุ ' + dt.suppliesCode + ' ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delDataTrack(dt.invoiceId)
        }
      })
    },
    delDataTrack (dt) {
      console.log('delDataTrack ID: ', dt)
      var LASTuserName = this.userData.userName
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Invoice_order/Invoice_delete",
          {
            invoiceId: dt,
            userName: this.userData.userName,
            LAST_USER: LASTuserName
          },
          {
            headers: this.getHeaderAPI('Invoice_delete', this.userData.userName)
          }
        )
        .then(async (response) => {
          console.log('delDataTrack resp: ', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ลบข้อมูลพัสดุเรียบร้อย","success")
            this.dataReady = true
            this.getDataTracking()
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถลบข้อมูลพัสดุได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลบข้อมูลพัสดุได้","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-mini{
  padding: 0.5rem;
  font-size: 0.75rem;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Tracking.vue